import { Statistic } from 'antd';
import styled from 'styled-components';

export const EditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  padding-left: 10px;
`;

export const TrendWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const StyledStatistic = styled(Statistic)`
  line-height: 1.25;
  height: 40px;

  .ant-statistic-title {
    margin-bottom: 0;
    color: #939393;
  }

  .ant-statistic-content,
  .ant-statistic-content-value {
    font-size: 14px;
    font-weight: 500;
    line-height: 0.5;
  }

  .ant-statistic-content-suffix {
    font-size: 16px;
  }
`;

export const VerticalDivider = styled.div`
  border: 1px solid #eee;
  position: absolute;
  left: 50%;
  height: 95%;
`;

export const HorizontalDivider = styled.div`
  border: 1px solid #eee;
  position: absolute;
  top: 50%;
  width: 98%;
`;

export const CardWrapper = styled.div`
  position: relative;
  height: 100px;
  overflow: hidden;
  padding-left: 3px;
  min-width: 150px;
  cursor: pointer;

  &:hover {
    background-color: #f2f8ff;
  }

  &.na-mode {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const StyledMetricCaption = styled.span`
  font-size: 12;
  color: rgb(140 140 140);
`;

export const StyledCardWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const StyledMetricTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    padding-left: 5px;
    color: #939393;
    font-size: 12px;
  }
`;
